// Product card color swatches: swaps the visible media on a product card and
// updates the card links to point at the selected variant.
//
// Defined globally so it is available on every template that renders product
// cards (collections, search, featured collections, related products, etc.),
// not only on the collection grid sections.
function cardProductColorSwatches(id, color, variantColorId) {
  const cardProductContainer = document.getElementById(`custom-multi-color-product-card-${id}`);
  if (!cardProductContainer) return;

  const cardProductLinks = document.querySelectorAll(`a[id*="${id}"]`);
  const mediaColor = cardProductContainer.querySelectorAll('.media');
  const dataColorValue = `${id}--${color}`;
  mediaColor.forEach((media) => {
    if (media.dataset.colorValue === dataColorValue) {
      media.classList.remove('tw-opacity-0');
    } else if (!media.classList.contains('tw-opacity-0')) {
      media.classList.add('tw-opacity-0');
    }
  });

  if (!variantColorId) return;

  cardProductLinks.forEach((link) => {
    try {
      const url = new URL(link.href);
      url.searchParams.set('variant', variantColorId);
      link.href = url.toString();
    } catch (e) {
      /* ignore links without a valid href */
    }
  });
}

// Auto-trigger color swatches based on URL filter parameter.
function triggerSelectedColorSwatches() {
  document.querySelectorAll('[data-selected="true"]').forEach(function (swatch) {
    swatch.click();
  });
}

document.addEventListener('DOMContentLoaded', triggerSelectedColorSwatches);
// Re-run when a product grid is updated (filter changes / infinite scroll).
document.addEventListener('productGridUpdated', triggerSelectedColorSwatches);
